const MarkSafe = ({Element, html, ...props}) => (
    <Element {...props} dangerouslySetInnerHTML={{__html: html}} />
);

MarkSafe.defaultProps = {
    Element: 'span',
};

export default MarkSafe;
